import {
  getPathToSiteDetails,
  getSiteDetailsTabBasePath,
} from "../../../site/details/utils/index"
import { SiteDetailsTab } from "../../../site/details/constants"
import qs from "query-string"

export function useBuildDetailsBackLink({ organizationId, siteId, location }) {
  let linkLabel
  let linkPath

  const returnTo = qs.parse(location.search).returnTo || ``
  linkPath = returnTo

  const pathToSiteDetails = getPathToSiteDetails(siteId, organizationId)
  const pathToProductionTab = getSiteDetailsTabBasePath(
    SiteDetailsTab.Production,
    siteId,
    organizationId
  )

  const pathToPreviewTab = getSiteDetailsTabBasePath(
    SiteDetailsTab.CmsPreview,
    siteId,
    organizationId
  )

  if (returnTo.includes(pathToPreviewTab)) {
    linkLabel = `CMS Preview`
  } else if (returnTo.includes(pathToProductionTab)) {
    linkLabel = `Production overview`
  } else if (!returnTo) {
    linkPath = pathToSiteDetails
    linkLabel = `Site overview`
  } else {
    linkLabel = `Go back`
  }

  return {
    label: linkLabel,
    to: linkPath,
  }
}
